import { useMemo, useRef } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { usePeersStore } from '@src/stores';
import { createElementColor } from '@src/helpers';

const useAvatarDisplay = (peerId: string) => {
  const avatarRef = useRef<HTMLImageElement>(null);

  const peerColor = usePeersStore(useShallow((state) => state.getPeerColor(peerId)));

  // Ensure the peer has a color assigned
  const { wavyColor, backgroundColor } = useMemo(() => {
    const backgroundColor = peerColor ? createElementColor(peerColor, 'wavy-background') : 'hsla(0, 0%, 50%, 1)';
    const wavyColor = peerColor ? createElementColor(peerColor, 'wavy-color') : null;

    return {
      wavyColor,
      backgroundColor,
    };
  }, [peerColor]);

  return { avatarRef, wavyColor, backgroundColor };
};

export default useAvatarDisplay;
